import { useState } from "react";
import "./editorialForms.css";

const causes = [
  { id: "environment", name: "Meio Ambiente" },
  { id: "animals", name: "Animais" },
  { id: "children", name: "Crianças" },
  { id: "health", name: "Saúde" },
  { id: "education", name: "Educação" },
  { id: "poverty", name: "Combate à Pobreza" },
  { id: "human_rights", name: "Direitos Humanos" },
  { id: "elderly", name: "Idosos" },
  { id: "disability", name: "Pessoas com Deficiência" },
  { id: "other", name: "Outra" },
];

export default function OngForm({ data, onChange }) {
  const [opportunityInput, setOpportunityInput] = useState("");

  const handleAddOpportunity = () => {
    if (opportunityInput.trim()) {
      const currentVolunteering = data?.volunteering || { available: true, opportunities: [] };
      onChange({
        ...data,
        volunteering: {
          ...currentVolunteering,
          opportunities: [...currentVolunteering.opportunities, opportunityInput.trim()],
        },
      });
      setOpportunityInput("");
    }
  };

  const handleRemoveOpportunity = (index) => {
    const currentVolunteering = data?.volunteering || { available: true, opportunities: [] };
    onChange({
      ...data,
      volunteering: {
        ...currentVolunteering,
        opportunities: currentVolunteering.opportunities.filter((_, i) => i !== index),
      },
    });
  };

  return (
    <div className="editorial_form ong_form">
      <div className="editorial_form_section">
        <label>
          Nome da Organização <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Instituto Esperança Viva"
          value={data?.organizationName || ""}
          onChange={(e) => onChange({ ...data, organizationName: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>
          Causa <span className="required">*</span>
        </label>
        <select
          value={data?.cause || ""}
          onChange={(e) => onChange({ ...data, cause: e.target.value })}
        >
          <option value="">Selecione uma causa</option>
          {causes.map((cause) => (
            <option key={cause.id} value={cause.id}>
              {cause.name}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_section">
        <label>Missão</label>
        <textarea
          placeholder="Qual é a missão da sua organização?"
          value={data?.mission || ""}
          onChange={(e) => onChange({ ...data, mission: e.target.value })}
          maxLength={1000}
          rows={2}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Descreva o trabalho da organização, projetos, impacto..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={2000}
          rows={4}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Website</label>
          <input
            type="url"
            placeholder="https://suaong.org.br"
            value={data?.website || ""}
            onChange={(e) => onChange({ ...data, website: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Link para Doações</label>
          <input
            type="url"
            placeholder="https://suaong.org.br/doe"
            value={data?.donationUrl || ""}
            onChange={(e) => onChange({ ...data, donationUrl: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Contato</label>
        <div className="editorial_form_row">
          <input
            type="email"
            placeholder="E-mail"
            value={data?.contact?.email || ""}
            onChange={(e) =>
              onChange({
                ...data,
                contact: { ...data?.contact, email: e.target.value },
              })
            }
          />
          <input
            type="tel"
            placeholder="Telefone"
            value={data?.contact?.phone || ""}
            onChange={(e) =>
              onChange({
                ...data,
                contact: { ...data?.contact, phone: e.target.value },
              })
            }
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Endereço</label>
        <input
          type="text"
          placeholder="Endereço da sede"
          value={data?.contact?.address || ""}
          onChange={(e) =>
            onChange({
              ...data,
              contact: { ...data?.contact, address: e.target.value },
            })
          }
        />
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="volunteeringAvailable"
            checked={data?.volunteering?.available !== false}
            onChange={(e) =>
              onChange({
                ...data,
                volunteering: {
                  ...data?.volunteering,
                  available: e.target.checked,
                },
              })
            }
          />
          <label htmlFor="volunteeringAvailable">Aceita voluntários</label>
        </div>
      </div>

      {data?.volunteering?.available !== false && (
        <div className="editorial_form_section">
          <label>
            Oportunidades de Voluntariado
            <button
              type="button"
              className="add_variant_btn"
              onClick={handleAddOpportunity}
            >
              + Adicionar
            </button>
          </label>
          <input
            type="text"
            placeholder="Ex: Ensinar crianças, Cuidar de animais..."
            value={opportunityInput}
            onChange={(e) => setOpportunityInput(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleAddOpportunity()}
          />
          <div className="genre_chips" style={{ marginTop: "8px" }}>
            {(data?.volunteering?.opportunities || []).map((opp, i) => (
              <span
                key={i}
                className="genre_chip selected"
                onClick={() => handleRemoveOpportunity(i)}
                style={{ cursor: "pointer" }}
              >
                {opp} ×
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
        <span>
          Compartilhe o trabalho da sua ONG e inspire mais pessoas a contribuir!
        </span>
      </div>
    </div>
  );
}
